// Deduplicated object-URL cache keyed by Blob identity. A FinalizationRegistry
// revokes each URL once its Blob is garbage-collected, so callers never have to
// track URL lifetimes by hand. Shared by the image stack (useCachedImage) and the
// resize fallback path (imageResize.client) so a given Blob always maps to a
// single, self-revoking URL — a raw URL.createObjectURL per call would leak.

const blobUrlCache = new WeakMap<Blob, string>();

const urlRegistry =
  typeof FinalizationRegistry !== 'undefined'
    ? new FinalizationRegistry<string>((url) => URL.revokeObjectURL(url))
    : null;

export const getOrCreateBlobUrl = (blob: Blob): string => {
  const cached = blobUrlCache.get(blob);
  if (cached) return cached;
  const url = URL.createObjectURL(blob);
  blobUrlCache.set(blob, url);
  urlRegistry?.register(blob, url);
  return url;
};
